// What KakaoTalk's own browser shows instead of the app (lib/inapp.ts,
// operations guide 9.1): the page was handed to the phone's browser, and
// if it is still here, how to get there, the address to copy, or going on
// here anyway. The app is not drawn until then, so the address keeps what
// the app would take out of it (/join#<token>).
import { type ReactNode, useRef, useState } from 'react'

import { openOutside, stayInKakaoTalk } from '../lib/inapp'

export function KakaoGate({ show, children }: { show: boolean; children: ReactNode }) {
  const [shown, setShown] = useState(show)
  const [copied, setCopied] = useState(false)
  const input = useRef<HTMLInputElement>(null)
  if (!shown) return children

  const url = location.href
  const copy = () => {
    const done = () => setCopied(true)
    // a WebView without the clipboard API: the selected text, the old way
    const byHand = () => {
      const el = input.current
      if (!el) return
      el.focus()
      el.select()
      try {
        if (document.execCommand('copy')) done()
      } catch {
        // the address stays selected, to copy with a long press
      }
    }
    if (navigator.clipboard?.writeText) navigator.clipboard.writeText(url).then(done, byHand)
    else byHand()
  }

  return (
    <div className="auth inapp-guide">
      <div className="card">
        <h2>브라우저에서 열어 주세요</h2>
        <p>카카오톡 안에서는 설치와 알림이 안 됩니다. 오른쪽 위 ⋮ → 다른 브라우저로 열기</p>
        <button type="button" className="primary" onClick={openOutside}>
          다른 브라우저로 열기
        </button>
        <input ref={input} readOnly value={url} aria-label="주소" onFocus={(e) => e.target.select()} />
        <button type="button" className="secondary" onClick={copy}>
          {copied ? '복사했습니다' : '주소 복사'}
        </button>
        <p className="muted small">복사한 주소를 Chrome 주소창에 붙여 넣어도 됩니다.</p>
        <button
          type="button"
          className="link"
          onClick={() => {
            stayInKakaoTalk()
            setShown(false)
          }}
        >
          카카오톡 안에서 계속 쓰기
        </button>
      </div>
    </div>
  )
}
